import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ResolveMergeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ResolveMergeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const resolveMerge = (request: ResolveMergeRequest, options?: CashRequestOptions) =>
  post<ResolveMergeRequest, ResolveMergeResponse>('/2.0/cash/resolve-merge', request, {
    ...options,
    rejectOnError: true,
  })
